module.exports = __webpack_public_path__ + "img/reward-8.fc01bc82.svg";